/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { createApiAction } from 'api/core';

import EntityContext from 'config/constants/schemas/EntityContext';

const updateSubscription = createApiAction({
  method: 'put',
  url: '/api/subscription/update',
  requestBodyMapper: ({
    cardToken
  }) => ({
    creditCardToken: cardToken
  }),
  responseMapper: () => ({
    updated: {
      contexts: [ EntityContext.Identity ]
    }
  })
});

export default updateSubscription;